// Copyright (c) Konnecta Systems. All rights reserved.
// Licensed under the Custom License. See LICENSE file in the project root for full license information.
// This was autogenerated by zAppDev.
import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class TimelineResource  {
    _originalTypeClassName = "Loom.BO.TimelineResource";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
TimelineResource.translate = translateService;
}
this.children = [];
this.id = null;
this.title = null;
this.duration = null;
this.start = null;
this.end = null;
this.effort = null;
this.TimelineResourceKey = null;
this._key = this.TimelineResourceKey = 0; 
}

static translate: TranslateService;
_key: any;
id:any;
title:any;
duration:any;
start:any;
end:any;
effort:any;
children:any;
private _TimelineResourceKey:any;
get TimelineResourceKey(): any {
    return this._TimelineResourceKey;
  }
set TimelineResourceKey(value: any) {
    this._TimelineResourceKey = value;
    this._key = value;
  }
static setchildren = ($this, items) => {
                if (items == null) items = [];
                if ($this.children == null) $this.children = [];

                const copyItems = Common.cloneObject(items);

                while ($this.children.length > 0) {
                    Domain.TimelineResource.removechildren($this, $this.children[0]);
                }

                Domain.TimelineResource.addManychildren($this, copyItems);
            }
static addManychildren = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.TimelineResource.addchildren($this, items[i]);
                }
            }
static addchildren = ($this, item) => {
                if ($this.children == null) $this.children = [];
                if (item == null || $this.children.indexOf(item) > -1) return;
                $this.children.push(item);
}
static addRangechildren = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.TimelineResource.addchildren($this, item));
            }
static removechildren = ($this, item) => {
                if ($this == null || $this.children == null || $this.children.indexOf(item) === -1) return;
                var _index = $this.children.indexOf(item);
                $this.children.splice(_index, 1);
}
static clearchildren = ($this) => { $this.children = null; }


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.TimelineResourceKey == null || $this.TimelineResourceKey == 0;
            }


}